import type { GameCardVariant } from '../types';
import type { MediaDto } from '@/queries/media/media.schema';
import { AppImage } from '@/components/ui/AppImage/AppImage';
import { cn } from '@/utils/cn';

export type GameCardCoverProps = {
  name: string;
  cover?: MediaDto | null;
  priority?: boolean;
  variant: GameCardVariant;
  pictureClassName?: string;
};

const GameCardCover = ({ name, cover, priority, variant, pictureClassName }: GameCardCoverProps) => {
  if (!cover || (!cover.key && !cover.path)) {
    return null;
  }

  return (
    <div
      className={cn(
        'w-full aspect-3/4 overflow-hidden rounded-xl lg:w-30 bg-c870',
        pictureClassName,
      )}
    >
      <AppImage
        src={cover.key ?? cover.path}
        alt={cover.meta?.alt || name}
        variant={variant}
        mimeType={cover.mimeType}
        priority={priority}
        className="w-full h-full"
      />
    </div>
  );
};

GameCardCover.displayName = 'GameCardCover';
export default GameCardCover;
